const reqContext = require.context('./svg', false, /.svg$/)
const bankContext = require.context('./svg/bank', false, /.svg$/)
const requireAll = reqContext => reqContext.keys().map(reqContext)
const requireBank = bankContext => bankContext.keys().map(bankContext)
requireAll(reqContext)
requireBank(bankContext)
